module.exports = __webpack_public_path__ + "0ffc915bf429c7a3b8e4e0132bd5d898.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_2_2023_chart.png
// module id = 1703
// module chunks = 0